module.exports = __webpack_public_path__ + "img/et.1ffe011f.svg";